import React, { useContext } from 'react';
import './App.css';


import { Route, HashRouter, BrowserRouter as Router, Routes, Navigate } from 'react-router-dom'
import { ToastContainer, toast, Slide } from 'react-toastify';
import { isLoggedIn } from './utils';
// import firebase from './firebase'


import Login from '../src/components/login';
import ForgotPassword from './components/forgot';
import ChangePassword from './components/change-password';
import Successfully from './components/successful';
import Header from './components/header';
import SideNav from './components/sidenav';
import Dashboard from './components/dashboard';
import SignUp from './components/signup';
import OtpVerification from './components/otp-verification';
import SignUpSuccessfully from './components/siginup-success';
import MyStore from './components/my-store';
import MyStoreEdit from './components/edit-my-store';
import ProductManagement from './components/product-management';
import ProductAdd from './components/product-add';
import ProductEdit from './components/product-edit';
import OrderManagement from './components/order-management';
import OrderDetails from './components/order-details';
import ReportManagement from './components/Report-management';
import Settings from './components/setting';
import Notification from './components/notifications';
import { Data } from '@react-google-maps/api';
import  { requestForToken ,onMessageListener} from './firebase';
import NotificationFirebase from './notification';
import ReportOrder from './components/report-order';
import ReportProduct from './components/report-product';
import ReportTransaction from './components/report-transaction';
import ReportAdmin from './components/report-admin';
import Sound from './components/sound';
// import { useContext } from 'react';
// import { SocketContext } from './components/socket-context';
import { useEffect } from 'react';
import { SocketContext } from './components/socket-context';
import SoundSocket from './components/socket-notification';
import { io } from 'socket.io-client';
// import Sound from './components/sound';
// import { SocketContext } from './components/socket-context';
const userdata = JSON.parse(localStorage.getItem("ownerLogin"));



function PrivateRoute({ component: Component, userType, ...rest }) {
  let isLogged = false;
  const checkAuth = () => {
    return isLoggedIn("ownerLogin");
  }

  if (checkAuth()) {
    isLogged = true;
  }
  return isLogged ? <Component checkAuth={checkAuth} /> : <Navigate to="/" />;
}




function App() {
 


  
//  const socket = useContext(SocketContext);
//  const queryClient =
// const socket = io("https://bayin.app:4000");
// const socket = useContext(SocketContext)
const socket = useContext(SocketContext)
  
  
useEffect(() => {
  socket.on('connect', () => {
    // console.log("GLOBAL SOCKET VALUE_-->", socket)
    socket.on('message', (data) => {
      // console.log("GLOBAL DATA_-->", data);
    })
  })

}, [])


// useEffect(() => {
//   socket.emit("room_join", {
//     roomId: userdata?._id
//     // sen/der_id: "61de72ac373b5d123a69c130",
//   });
// }, []);


  return (
    
    <React.Fragment>
      <ToastContainer transition={Slide} />
      {/* <NotificationFirebase/>  */}
     
      <HashRouter> 
      <SoundSocket/>
      {/* <Sound/> */}
        <Routes>
       
          <Route path="/" element={<Login />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/successful" element={<Successfully />} />
          <Route path="/header" element={<PrivateRoute component={Header} />} />
          <Route path="/sidenav" element={<PrivateRoute component={SideNav} />} />
          <Route path="/dashboard" element={<PrivateRoute component={Dashboard} />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/otp-verification" element={<OtpVerification />} />
          <Route path="/siginup-success" element={<SignUpSuccessfully />} />
          <Route path="/my-store" element={<PrivateRoute component={MyStore} />} />
          <Route path="/edit-my-store" element={<PrivateRoute component={MyStoreEdit} />} />
          <Route path="/product-management" element={<PrivateRoute component={ProductManagement} />} />
          <Route path="/product-add" element={<PrivateRoute component={ProductAdd} />} />
          <Route path="/product-edit" element={<PrivateRoute component={ProductEdit} />} />
          <Route path="/order-management" element={<PrivateRoute component={OrderManagement} />} />
          <Route path="/order-details" element={<PrivateRoute component={OrderDetails} />} />
          <Route path="/Report-management" element={<PrivateRoute component={ReportManagement} />} />
          <Route path="/setting" element={<PrivateRoute component={Settings} />} />
          <Route path="/report-transaction" element={<PrivateRoute component={ReportTransaction} />} />
          <Route path="/report-product" element={<PrivateRoute component={ReportProduct} />} />
          <Route path="/report-order" element={<PrivateRoute component={ReportOrder} />} />
          <Route path="/notifications" element={<PrivateRoute component={Notification} />} />
          <Route path="/report-admin" element={<PrivateRoute component={ReportAdmin} />} />
        </Routes>
      </HashRouter>
    </React.Fragment>
  );
}


export default App;
